export const messages = {
  en: {
    reportOnlinePropertyPay: {
      search: {
        title: 'Search Conditions',
        orderId: 'Merchant order number (WYF)',
        transactionId: 'Wechat transaction ID',
        payerObjName: 'Room number',
        ownerName: 'Owner name',
        payState: 'Payment status',
        startTime: 'Please select order start time',
        endTime: 'Please select order end time',
        community: 'Please select community'
      },
      table: {
        title: 'Wechat Property Fee Payment',
        tooltip: 'Online property fee payments initiated by owners via the mall mini program, one row per payment order',
        orderId: 'Merchant Order Number',
        transactionId: 'Wechat Transaction ID',
        community: 'Community',
        roomOwner: 'Room/Owner',
        feeNames: 'Fee Items',
        feePeriod: 'Fee Period',
        payState: 'Payment Status',
        totalFee: 'Order Amount(Yuan)',
        createTime: 'Order Time'
      },
      state: {
        ALL: 'All Statuses',
        W: 'Pending Payment',
        C: 'Payment Success',
        WT: 'Pending Refund',
        CT: 'Refund Completed',
        FT: 'Refund Failed',
        PF: 'Payment Failed'
      },
      summary: {
        total: 'Total order amount (all filtered records)',
        yuan: 'Yuan'
      },
      explanation: {
        defaultFilter: 'Only paid (received) records are shown by default; refund records can be viewed via the status filter',
        orderId: 'Merchant order number: the WYF online payment order number, which can be used to look up the order in the Wechat merchant platform',
        transactionId: 'Wechat transaction ID: the unique payment order number returned by Wechat callback after payment success, corresponding to the Wechat merchant platform transaction details',
        wState: 'Pending payment orders have no payment details until paid successfully'
      },
      fetchError: 'Failed to fetch wechat property fee payments',
      dateError: 'The start time must be earlier than the end time'
    }
  },
  zh: {
    reportOnlinePropertyPay: {
      search: {
        title: '查询条件',
        orderId: '商户单号（WYF）',
        transactionId: '微信支付单号',
        payerObjName: '房号',
        ownerName: '业主姓名',
        payState: '支付状态',
        startTime: '请选择下单开始时间',
        endTime: '请选择下单结束时间',
        community: '请选择小区'
      },
      table: {
        title: '微信物业费缴纳',
        tooltip: '业主通过商城小程序线上自助缴纳的物业费，一行对应一个缴费单',
        orderId: '商户单号',
        transactionId: '微信支付单号',
        community: '小区',
        roomOwner: '房号/业主',
        feeNames: '费用项',
        feePeriod: '缴费周期',
        payState: '支付状态',
        totalFee: '订单金额(元)',
        createTime: '下单时间'
      },
      state: {
        ALL: '全部状态',
        W: '待支付',
        C: '支付成功',
        WT: '待退费',
        CT: '退费完成',
        FT: '退费失败',
        PF: '支付失败'
      },
      summary: {
        total: '订单金额合计（当前筛选全部记录）',
        yuan: '元'
      },
      explanation: {
        defaultFilter: '默认仅展示支付成功（实收）的单据；退费类单据请通过状态下拉筛选查看',
        orderId: '商户单号：线上缴费 WYF 订单号，可在微信商户平台按此单号查询订单',
        transactionId: '微信支付单号：支付成功后微信回调返回的唯一交易单号，与微信商户平台交易详情对应',
        wState: '待支付订单在支付成功前无缴费明细，房屋/费用项等信息为空'
      },
      fetchError: '查询微信物业费缴纳列表失败',
      dateError: '开始时间必须早于结束时间'
    }
  }
}
